import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Container,
  Paper,
  Typography
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import authService from '../../services/authService';

const ForgotPasswordModal = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!email) {
      setError('Email is verplicht.');
      return;
    }

    if (!validateEmail(email)) {
      setError('Ongeldig emailadres.');
      return;
    }

    setLoading(true);
    const result = await authService.forgotPassword(email);
    setLoading(false);

    if (result.success) {
      setSuccess(true);
      setEmail('');
    } else {
      setError(result.message);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        padding: 2
      }}
    >
      <Container maxWidth="sm">
        <Paper
          sx={{
            padding: 4,
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <Button
              startIcon={<ArrowBack />}
              onClick={onBack}
              sx={{ mr: 'auto', textTransform: 'none' }}
            >
              Terug
            </Button>
          </Box>

          <Typography variant="h5" sx={{ textAlign: 'center', mb: 3, fontWeight: 'bold' }}>
            Wachtwoord herstellen
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Email verzonden! Controleer uw inbox voor een link om uw wachtwoord herstellen.
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading || success}
              sx={{ mb: 2 }}
            />

            <Button
              fullWidth
              variant="contained"
              type="submit"
              disabled={loading || success}
              sx={{ mt: 2 }}
            >
              {loading ? <CircularProgress size={24} /> : 'Email versturen'}
            </Button>
          </form>

          <Typography variant="body2" sx={{ textAlign: 'center', mt: 3, color: '#666' }}>
            U ontvangt een email met een link om uw wachtwoord herstellen.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default ForgotPasswordModal;
